import {useEffect} from "react";
import * as React from "react";
import {
    Box,
    Button,
    CardContent,
    Dialog, DialogActions, DialogContent, DialogContentText,
    DialogTitle,
    Grid,
    Paper, TextField, Typography
} from "@mui/material";
import {submitAnswerWriteAnswer, useApi} from "../api/Api";
import {useTranslation} from "react-i18next";

const QuestionWriteAnswer = ({question, fetchQuizStats, fetchCurrentQuestion}) => {
    const {t} = useTranslation();
    const api = useApi();

    const [answer, setAnswer] = React.useState("");

    const [openAlert, setOpenAlert] = React.useState(false);
    const [feedback, setFeedback] = React.useState("");
    const [correct, setCorrect] = React.useState();
    const [solution, setSolution] = React.useState();
    const [changeQuestion, setChangeQuestion] = React.useState(false);

    const handleClose = () => {
        setOpenAlert(false);
        setFeedback("");
        if (changeQuestion) {
            fetchCurrentQuestion();
            fetchQuizStats();
        }
    };

    useEffect(() => {
        if (!!feedback)
            setOpenAlert(true);
    }, [feedback]);


    const submitAnswer = (answer) => {
        submitAnswerWriteAnswer(api, answer)
            .then((response) => {
                let data = response["data"];
                setCorrect(data["correct"]);
                setFeedback(data["feedback"]);
                setSolution(data["solution"]);
                setChangeQuestion(data["change_question"]);
            })
            .catch((error) => console.log(error));
    };

    return (
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
            <Paper elevation={10} sx={{m: 1, p: 1, maxWidth: 1000}}>
                <CardContent>
                    {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_type")}: {t("write_answer")}</Typography>*/}
                    {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_no")} {question["questionid"]}</Typography>*/}
                    {question["description"]}
                    <Box sx={{mt: 2}} textAlign="center">
                        <TextField label="Answer"
                                   required={true}
                                   onChange={(e) => setAnswer(e.target.value)}
                        />
                    </Box>
                </CardContent>
                <Box textAlign="center" xs={{m: 2}}>
                    <Button variant="contained" onClick={() => submitAnswer(answer)}>{t("submit_answer")}</Button>
                </Box>
            </Paper>
            <Dialog
                open={openAlert}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {correct ? t("correct_answer") : t("incorrect_answer")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {feedback}
                        {solution === undefined ?
                            (
                                <></>
                            ) : (
                                <Box sx={{mt: 2}}>
                                    <Typography variant="h6">{t("solution")}</Typography>
                                    <Typography>{solution["answer"]}</Typography>
                                </Box>
                            )
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{t("close")}</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}

export default QuestionWriteAnswer;